import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpPrintSiar, HttpPrintSiarOptions} from '../http/projects.http'
import {MUTATION_KEYS} from '@/queryClient'
import {FormErrorResponse} from '@/types'
import {AxiosError} from 'axios'

export const useStorePrintSiar = ({
    projectId,
    options
}: {
    projectId: string
    options?: UseMutationOptions<Blob, AxiosError<FormErrorResponse>, HttpPrintSiarOptions['payload']>
}) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.PRINT_SIAR],
        mutationFn: payload => httpPrintSiar({urlParams: {projectId}, payload}),
        ...options
    })
}
